import { render, staticRenderFns } from "./LogsTable.vue?vue&type=template&id=5ac1b6d1&scoped=true"
import script from "./LogsTable.vue?vue&type=script&lang=js"
export * from "./LogsTable.vue?vue&type=script&lang=js"
import style0 from "./LogsTable.vue?vue&type=style&index=0&id=5ac1b6d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac1b6d1",
  null
  
)

export default component.exports